import About from './components/About';
import Navbar from './components/Navbar';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Gallery from './components/Gallery';
import Menu from './components/Menu';
import Bean from './components/Beans';
import Brew  from './components/Brew';
import Signatures from './components/Signatures';
import Consulting from './components/Consulting';


function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <About />
      <Consulting />
      <Bean />
      <Brew />
      <Signatures />
      <Menu />
      <Gallery />
      <Contact />
      <Footer />
      
    </div>
    
  );
}

export default App;
